import { render, staticRenderFns } from "./Activite_Inscription.vue?vue&type=template&id=5fc9c89e&scoped=true&"
import script from "./Activite_Inscription.vue?vue&type=script&lang=js&"
export * from "./Activite_Inscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc9c89e",
  null
  
)

export default component.exports